<template>
    <div :id="page_slug">

        <div class="crumbs-bar">
            <el-row>
                <el-col :span="12">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ name: 'ProductList' }">Products</el-breadcrumb-item>
                        <el-breadcrumb-item>Add</el-breadcrumb-item>
                    </el-breadcrumb>        
                </el-col>      
            </el-row>
        </div>

        <el-form 
            ref="product" 
            :model="product"
            :rules="rules.product"
            :label-position="label_position">

            <el-form-item label="Status">
              <el-switch
                :active-value="1"
                :inactive-value="0"
                active-text="Enabled"
                inactive-text="Disabled"
                v-model="product.enabled">
              </el-switch>
            </el-form-item>

              <el-form-item>
             <el-switch
              :active-value="1"
              :inactive-value="0"
              active-text="Can Be Purchased"
              inactive-text="Can Not Be Purchased"
              v-model="product.can_be_purchased">
            </el-switch>  
          </el-form-item>

            <!-- <el-tab-pane v-if="product.can_be_purchased" :disabled="!product.can_be_purchased == true" label="Pricing Tiers" name="pricing_tiers"> -->
            

          
            <el-form-item label="Name" prop="name">
                <el-input v-model="product.name"></el-input>
            </el-form-item>

            <el-form-item label="SKU" prop="sku">
                <el-input v-model="product.sku"></el-input>
            </el-form-item>

            <el-form-item label="">
                <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    active-text="Editable"
                    inactive-text="Not Editable"
                    v-model="product.is_editable">
                </el-switch>
            </el-form-item>

            <el-row :gutter="30">
                <el-col :span="12">
                    <el-form-item label="Product Type" prop="product_type_id">
                        <el-select
                            v-model="product.product_type_id" 
                            placeholder="Product type"
                            value-key="id">
                            <el-option
                                v-for="item in product_types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>                
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="Tax Class" prop="tax_class_id">
                        <el-select  
                            :span="12"
                            v-model="product.tax_class_id" 
                            placeholder="Tax class"
                            value-key="id">
                            <el-option
                                v-for="item in tax_classes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>                
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="Specification" prop="specification">
                <el-input type="textarea" :rows="2" :autosize="false" v-model="product.specification"></el-input>
            </el-form-item>
            
            <el-form-item label="Short Description" prop="short_description">
                <el-input type="textarea" :rows="3" :autosize="false" v-model="product.short_description"></el-input>
            </el-form-item>

            <el-form-item label="Description" prop="description">
                <el-input type="textarea" :rows="5" :autosize="false" v-model="product.description"></el-input>
            </el-form-item>

            <el-form-item label="Recommended Margins">
                <div v-if="product.min_recommended_margin == 0 && product.max_recommended_margin == 0">   
                <div style="margin-top: 15px; width:500px;" >
                  <el-input placeholder="Please input" 
                      v-model="quote.markup"
                      :min="0"
                      :max="100"
                      :step="5"
                      :show-stops="false">
                    <template slot="append">%</template>
                  </el-input>
                </div>
                </div>

                <div v-else>
                  <el-input
                    v-model="quote.markup"
                    :min="product.min_recommended_margin"
                    :max="product.max_recommended_margin"
                    :step="5"
                    :show-stops="false">
                  </el-input>
                </div>  
            </el-form-item>

            <el-row>

            <el-form-item label="Track Inventory">
              <el-switch
                :inactive-value="0"
                :active-value="1"
                v-model="product.track_inventory">
              </el-switch>
            </el-form-item>

                <el-col :span="11">
                    <el-form-item label="Stock Level">
                        <el-input v-model="product.stock_level" :disabled="product.track_inventory == 0"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="11" :offset="2">
                    <el-form-item label="Alow Backorder" :span="12">
                        <el-switch
                            :disabled="product.track_inventory == 0"
                            :inactive-value="0"
                            :active-value="1"
                            v-model="product.allow_backorder">
                        </el-switch>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="Pricing Method">
                <el-switch
                    :active-value="1"
                    :inactive-value="0"
                    active-text="Tiered"
                    inactive-text="Ranged"
                    v-model="product.is_tiered">
                </el-switch>

                <span class="form-hint"><i class="el-icon-warning"></i> If the pricing will be set quantities i.e. 200,30 etc then set to tiered. Use ranged if you allow the user to enter a quantity they want.</span> 
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="addProduct('product')">Add</el-button>
            </el-form-item>

        </el-form>

        <pre>{{$data}}</pre>
    </div>
</template>

<style>

</style>

<script>
    import Config from '@/store/Config.js';
    import Utils from '@/components/utils/Utils.js';
    import Auth from '@/components/auth/AuthCheck.js';

    export default {
        data: function() {
            return {
                config: Config.config,
                page_alias: 'Add Product',
                page_slug: 'add-product',
                label_position: 'left',
                loading: false,
                
                margin_range: [],
                suppliers: [],
                product_types: [],
                tax_classes: [],
                product: {
                    name: '',
                    sku: '',
                    product_type_id: '',
                    tax_class_id: '',
                    specification: '',
                    short_description: '',
                    description: '',
                    track_inventory: '',
                    stock_level: '',
                    allow_backorder: '',
                    supplier_id: '',
                    is_tiered: null,
                    is_editable: '',
                },

                quote: {
                selected_tier: {},
                quantity: 0,
                markup: 0,
                unit_price_selected: 1,
                cost_price: '',
                sell_price: '',
                gross_profit: ''
                },

                rules: {
                    product: {
                        name: [
                            { required: true, message: 'Please Enter Name', trigger: 'blur' }
                        ],
                        product_type_id: [
                            { required: true, message: 'Please select Product Type', trigger: 'blur' }
                        ],
                        tax_class_id: [
                            { required: true, message: 'Please select Tax Class', trigger: 'blur' }
                        ],
                        specification: [
                            { required: true, message: 'Please Enter Specification', trigger: 'blur' }
                        ],
                        short_description: [
                            { required: true, message: 'Please Enter Short Description', trigger: 'blur' }
                        ],
                        description: [
                            { required: true, message: 'Please Enter Description', trigger: 'blur' }
                        ],
                    },
                }
            };
        },

        mounted: function() {
            const me = this;
            me.getProductTypes();
            me.getTaxClasses();
        },

        methods: {
            addProduct: function(formName) {
                console.log('Add Product Function');
                const me = this;
                var jwt = Utils.decodejwt();
                me.$refs[formName].validate((valid) => {
                if (valid) {
                    me.product.created_user_id = jwt.sub;
                    me.product.updated_user_id = jwt.sub;
                    me.product.min_recommended_margin = me.margin_range[0];
                    me.product.max_recommended_margin = me.margin_range[1];
                    me.$http.post(me.config.api + 'product', me.product).then(
                        response => {
                        console.log('Success posting data')  
                        console.log(response.status);
                        console.log(response.statusText);
                        me.$notify({
                            title: 'Success',
                            message: 'The Product Was Added',
                            type: 'success'
                        });
                        me.resetForm(formName);
                        var productId = response.body.data.id;
                        me.$router.push({ name: 'ProductEdit', params: { id: productId }});
                        }, response => {
                            console.log('Error posting data');
                            console.log(response.status);
                            console.log(response.statusText);
                        }
                    );
                    } else {
                        console.log('Fields Not Valid');
                        return false;
                    }
                });
            },

            getProductTypes: function() {
                console.log('get product types function');
                const me = this;
                me.$http.get(me.config.api + 'product-type', {params: {pagination: 1000}}).then(
                response => {
                    console.log('Success Getting Data')  
                    // get status
                    console.log(response.status);
                    // get status text
                    console.log(response.statusText);
                    // get body data
                    me.product_types = response.body.data;
                }, response => {
                    // error callback
                    console.log('Error Getting Data');
                    // get status
                    console.log(response.status);
                    // get status text
                    console.log(response.statusText);
                });
            },

            getTaxClasses: function() {
                console.log('get product types function');
                const me = this;
                me.$http.get(me.config.api + 'taxClasses', {params: {pagination: 1000}}).then(
                response => {
                    console.log('Success Getting Data')  
                    // get status
                    console.log(response.status);
                    // get status text
                    console.log(response.statusText);
                    // get body data
                    me.tax_classes = response.body.data;
                }, response => {
                    // error callback
                    console.log('Error Getting Data');
                    // get status
                    console.log(response.status);
                    // get status text
                    console.log(response.statusText);
                });
            },            

            resetForm(formName) {
                const me = this;
                this.$refs[formName].resetFields();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/products/ProductAdd.vue